import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../../api/api.service';

export interface GiftVoucherInterface {
  code: string;
  quantity: string;
  isValid: string;
  isGift: string;
  button: {
    design: string,
    value: string,
    spiritual: string
  };
}

@Injectable()
export class GiftService {
  constructor(
    private apiService: ApiService
  ) { }
  
  public voucherCheck(code: string): Observable<GiftVoucherInterface> {
    return this.apiService.post('voucher/check', {
      voucher: code
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/microsites/gift/gift.service.ts